import "./App.css";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./Pages/Login/Loginpage";
import LandingPageDashboard from "./Pages/Landingpage/Landingpage";
import LeaveRequestForm from "./Pages/LeaveRequest/LeaveForm";
import RegistrationForm from "./Pages/Registration/landing";
import ActivateUSB from "./Pages/ActivateUSB";
import AssetRequest from "./Pages/AssetRequest";
import VendorMaster from "./Pages/VendorMaster";
import Timetracker from "./Pages/DailyTimetracker";
import EOL from "./Pages/EOL";
import Softwareaccess from "./Pages/SoftwareAccess";
import Newpage from "./Pages/newlandingpage";
import PowerBipage from "./Pages/Powerbi";
import Vpn from "./Pages/VPNRequest";
import Thermal from "./Pages/thermal_dashboard";
import PD from "./Pages/PD_digital";
import Simulation from "./Pages/simulationPD";
import Reject from "./Pages/rejects";
import Mailack from "./Pages/mailack_datasharing";
import User from "./Pages/VendorUser";
// import Vendoraccessreq from "./Pages/AccessreqVendor";
import SwitchOn from "./Pages/SwitchOn/SwitchOnHomePage";
// import SwitchOnViewRequest from "./Pages/SwitchOn/IL1";
// import SwitchOnViewRequest from "./Pages/SwitchOn/SwitchOnIdeaListTable";
// import IL2StageView from "./Pages/SwitchOn/IndividualIdeaView";
import Vendorprofile from "./Pages/VendorProfile";
import Noc from "./Pages/Noc";
import Usbreject from "./Pages/usb_reject";
import SwitchScanPrivacyPolicy from "./Pages/MobileApp/switch_scan/privacy_policy";
import SwitchOnePrivacyPolicy from "./Pages/MobileApp/switch_one/privacy_policy";
import PPR from "./Pages/PPR";
import SwitchGOPrivacyPolicy from "./Pages/MobileApp/switch_go/privacy_policy";
import SwitchNgagePrivacyPolicy from "./Pages/MobileApp/switch_ngage/privacy_policy";
import Swipex from  "./Pages/NewSwipeX/Index/index";
import ITaccessories from "./Pages/ITaccessories/Index/index"
// import Swipex from "./Pages/swipex/Index/index"
import NewTimeSheet from "./Pages/NewTimeSheet/Index";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/landingPage" exact element={<Newpage />} />
        <Route path="/registration" exact element={<RegistrationForm />} />
        <Route path="/request_activate" exact element={<ActivateUSB />} />
        <Route path="/LeaveRequest" exact element={<LeaveRequestForm />} />
        <Route path="/assetrequest" exact element={<AssetRequest />} />
        <Route path="/vendormaster" exact element={<VendorMaster />} />
        <Route path="/timetracker" exact element={< NewTimeSheet/>} />
        <Route path="/EOL" exact element={<EOL />} />
        <Route path="/software_access" exact element={<Softwareaccess />} />
        <Route path="/newpage" exact element={<LandingPageDashboard />} />
        <Route path="/powerreport" exact element={<PowerBipage />} />
        <Route path="/vpn_access" exact element={<Vpn />} />
        <Route path="/thermal" exact element={<Thermal />} />
        <Route path="/PD" exact element={<PD />} />
        <Route path="/simulations" exact element={<Simulation />} />
        <Route path="/reject" exact element={<Reject />} />
        <Route path="/mailack" exact element={<Mailack />} />
        <Route path="/userdata" exact element={<User />} />
        <Route path="/switchon" exact element={<SwitchOn />} />
        {/* <Route path="/ITproducts" exact element={<ITproducts />} />
        <Route path="/ITstatus" exact element={<ITstatus />} />
        <Route path="/ITadmin" exact element={<ITadmin />} /> */}

        <Route path="/ITaccessories" exact element={<ITaccessories />} />
        {/* <Route path="/swipex" exact element={<Swipex />} /> */}

        {/* <Route path="/switchonviewrequest" exact element={<SwitchOnViewRequest />} /> */}
        {/* <Route path="/IL2" exact element={<IL2StageView />} /> */}
        {/* <Route path="/IL2" exact element={<IL2StageView />} /> */}
        {/* <Route path="/IL2" exact element={<IL2StageView />} /> */}
        {/* <Route path="/switchonviewrequest" exact element={<SwitchOnViewRequest />} />
        <Route path="/IL2" exact element={<IL2StageView />} /> */}
        <Route path="/userprofile" exact element={<Vendorprofile />} />
        <Route path="/noc" exact element={<Noc />} />
        <Route path="/usbreject" exact element={<Usbreject />} />
        <Route path="/switchscan/privacy-policy" exact element={<SwitchScanPrivacyPolicy />} />
        <Route path="/switchone/privacy-policy" exact element={<SwitchOnePrivacyPolicy />} />
        <Route path="/ppr" exact element={<PPR />} />

        <Route path="/switchgo/privacy-policy" exact element={<SwitchGOPrivacyPolicy />} />
        <Route path="/switchn-gage/privacy-policy" exact element={<SwitchNgagePrivacyPolicy />} />
        <Route path="/swipex" exact element={<Swipex />} />
        {/* <Route path="/vendoraccessreq" exact element={<Vendoraccessreq />} /> */}




      </Routes>
    </div>
  );
}

export default App;
